module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/ant-portuguese.b547e529.jpg";